import React from "react";
import { Route, Redirect } from "react-router-dom";

export const ProtectedRoute = ({
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
          if(localStorage.getItem('role') === "SystemAdmin"){

              return <Component key={props.match.params.id}  {...props} />;
            }else{
                return <Redirect to='/404'/>
            }

      }}
    />
  );
};
